/**
 * Scribe — settings page.
 *
 * Route: /prioritization/settings/scribe-agent
 *
 * On the agent template since migration 942 (SPEC-custom-agent-template.md
 * T2): the template's common settings page with the draft_items panel. Its old
 * settings table (scribe_agent_config) is retired — DEP-039.
 */

import { TemplateAgentSettings } from '../../../components/agents/TemplateAgentSettings';
import { SCRIBE } from '../../../lib/ai/agentDefinitions';

export default function ScribeAgent() {
  return <TemplateAgentSettings def={SCRIBE} />;
}
